import { Button, Modal, Text, TextArea } from '@viapeople/components'
import type React from 'react'
import { useState } from 'react'

interface RejectionReasonDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: (reason?: string) => void
	isSubmitting?: boolean
}

export const RejectionReasonDialog: React.FC<RejectionReasonDialogProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isSubmitting = false,
}) => {
	const [rejectionReason, setRejectionReason] = useState('')

	const handleConfirm = () => {
		onConfirm(rejectionReason.trim() || undefined)
	}

	const handleClose = () => {
		setRejectionReason('')
		onClose()
	}

	return (
		<Modal title='Reject evaluation' isOpen={isOpen} onClose={handleClose} className='max-w-lg'>
			<div className='p-6'>
				<div className='mb-4'>
					<Text variant='medium' className='text-neutral-600'>
						Are you sure you want to reject this evaluation? You can optionally provide a reason for the rejection.
					</Text>
				</div>

				<div className='mb-6'>
					<label htmlFor='rejection-reason' className='block mb-2'>
						<Text variant='small' weight='regular' className='text-neutral-700'>
							Rejection reason (optional)
						</Text>
					</label>
					<TextArea
						id='rejection-reason'
						value={rejectionReason}
						onChange={(e) => setRejectionReason(e.target.value)}
						placeholder='Enter reason for rejection...'
						className='w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-none'
						rows={4}
					/>
				</div>

				<div className='flex gap-3 justify-end'>
					<Button variant='secondary' onClick={handleClose}>
						Cancel
					</Button>
					<Button variant='destructive' onClick={handleConfirm} disabled={isSubmitting}>
						{isSubmitting ? 'Rejecting...' : 'Reject'}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
